import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Outlet, useNavigate } from 'react-router-dom';
import UserContext from '../../hooks/UserContext';
import AvatarUpload from '../../components/AvatarUpload';
import Api from '../../utils/Api';

const styles = css`
display: flex;
flex-direction:column;
width: 100%;
gap: 40px;
padding: 5px;

  .page-header {
    display: flex;
    flex-direction: column;
    gap: 20px;

    > .title {
      font-size: 2em;
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;

    .profile-upload {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap:10px;
    }

    .text {
        display: flex;
        flex-direction: column;
        align-items:center;
        font-weight: bold;
      }
    .buttons {
      display: flex;
      gap: 10px;
    }
  }
  `;

const AccountLayout = styled(({ className }) => {

  const navigate = useNavigate();
  const { user, updateUser } = useContext(UserContext);

  const onAvatarUploaded = async url => {
    let [error, newUser] = await Api.updateProfile({ avatar: url });
    if (error) console.error(error);
    else updateUser(newUser);
  }
  return (
    <div className={className}>
      <div className='page-header'>
        <div className='user-info'>
          <div className='profile-upload'>
            <AvatarUpload onUploaded={onAvatarUploaded} avatar = {user?.avatar}/>
          </div>
          <div className='text'>
            <div className='name'>
              {`${user.firstname} ${user.lastname}`}
            </div>
            <div className='email'>
              {user.email}
            </div>
          </div>
          <div className='buttons'>
            <div>
              <button className='danger' onClick={() => navigate('/login')}>Logout</button>
            </div>
            <div>
              <button className='primary' onClick={() => navigate('/change-password')}>Change Password</button>
            </div>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  )
})`${styles}`;

export default AccountLayout;
